<script>
  import {onMount, beforeUpdate, afterUpdate} from 'svelte'
  import db from '../db'
  import state from '../states'
let chartName
let charts  = state.charts
let chart = state.chart

const createChart = async() =>{
  if(chartName != undefined){
      let res = await db.charts.add({
	name:chartName,
  })
    charts.set(getCharts())
  }

}

const handleDelete = (idx) =>{
  db.charts.where('id').equals(idx).delete()
  charts.set(getCharts())
}

const getCharts = async()=>{
  let charts = await db.charts.toArray()
  console.log(charts)
  return charts
}


onMount(()=>{
 charts.set(getCharts())
})
</script>
<div class="bg-indigo-400 w-screen text-center text-gray-800 p-4">
Your Escape charts
</div>
  <div class="bg-gray-800">
<input bind:value={chartName}/>
   <button class="bg-gray-400 p-2  w-12 h-12" on:click={createChart}> ADD </button>
</div>
<div class="overflow-auto  h-screen w-full">
  {#await $charts then chartlist}
  {#each chartlist as item, idx}
    <div class="p-px flex hover:bg-gray-300 w-full"> 
      <div class="flex-1 capitalize">{item.name} </div>
      <div class="flex-last pr-6">
      <button class="bg-indigo-400 px-2 border-0 hover:bg-indigo-700 hover:text-white" on:click={()=>{chart.set(item.id) }} >Show</button>
      <button class="bg-indigo-400 text-red-800  px-2 border-0 hover:bg-indigo-700 hover:text-red-300" on:click="{()=>handleDelete(item.id)}">Delete</button>
      </div>
    </div>
  {/each}
  {/await}

</div>
